<template>
	<div class="meeting-calendar max-content">
		<banner :type="type" class="banner"></banner>
		<!-- <van-search v-model="keywords" placeholder="请输入关键词搜索会议" shape="round" @search="goSearch"/> -->
		<calendar ref="calendar" @changeMonth="getMonthMeetings" @changeDay="dateInRange" class="calendar"></calendar>
		<div class="meeting-container">
			<div class="meeting-list1" v-if="dayMeetings.length > 0">
				<div class="meeting-header">
					<h3 class="title">当日会议</h3>
					<span class="meeting-number">{{ dayMeetings.length }}场会议</span>
				</div>
				<div class="list-bg">
					<div class="item" v-for="(item, index) in dayMeetings" :key="index"
						@click="goDetail(item.id, item.buttons_count)">
						<span class="color-line" :style="{ 'background-color': colors[item.color_index % 5] }"></span>
						<div class="content">
							<div class="name">{{ item.name }}</div>
							<div class="bottom">
								<p v-if="item.city">地点：{{ item.province + " " + item.city }}</p>
								<p v-else>地点：{{ item.province }}</p>
								<p>{{ item.start_at }}-{{ item.end_at }}</p>
							</div>
						</div>
						<div class="image">
							<img :src="item.banner" />
						</div>
					</div>
				</div>
			</div>
			<div class="meeting-list1" v-if="monthMeetings.length > 0">
				<div class="meeting-header">
					<h3 class="title">当月会议</h3>
					<span class="meeting-number">{{ monthMeetings.length }}场会议</span>
				</div>
				<div class="list-bg">

					<div class="item" v-for="(item, index) in monthMeetings" :key="index"
						@click="goDetail(item.id, item.buttons_count)">
						<span class="color-line" :style="{ 'background-color': colors[index % 5] }"></span>
						<div class="content">
							<div class="name">{{ item.name }}</div>
							<div class="bottom">
								<p v-if="item.city">地点：{{ item.province + " " + item.city }}</p>
								<p v-else>地点：{{ item.province }}</p>
								<p>{{ item.start_at }}-{{ item.end_at }}</p>
							</div>
						</div>
						<div class="image">
							<img :src="item.banner" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabbar :active="index"></tabbar>
	</div>
</template>
<script>
import Calendar from '../components/Calendar'
import ItemBlock from '../components/ItemBlock'
import Banner from '../components/Banner'
import Tabbar from '../components/Tabbar'
import { MeetingMonth, MeetingsSearch } from '../../../config/interface.js'
export default {
	components: {
		Calendar,
		ItemBlock,
		Banner,
		Tabbar,
	},
	data() {
		return {
			count: 0,
			calendar_active: 0,
			type: 12,
			index: 0,
			monthMeetings: [],  //本月会议
			monthMeetings2: [], //本月会议(未做处理的数据)
			dayMeetings: [],    //今日会议
			historyWords: [],      //历史搜索
			currentYear: new Date().getFullYear(),
			currentMonth: new Date().getMonth() + 1,
			currentDay: new Date().getDate(),
			keywords: '',
			loading: false,
			resultMeetings: [],
			colors: ['#4B85ED', '#FDA245', '#57C393', '#FF8288', '#C783FC']
		}
	},
	watch: {
		calendar_active(newValue, oldValue) {
			this.count <= 0 ? this.count++ : '';
			newValue == 0 && this.count == 1 ? this.getMonthMeetings(this.currentMonth, this.currentYear) : '';
		}
	},
	mounted() {
		this.calendar_active = this.$route.params.calendar_active ? this.$route.params.calendar_active : 0;
		this.calendar_active == 0 ? this.getMonthMeetings(this.currentMonth) : '';
		this.currentMonth = this.currentMonth < 10 ? '0' + this.currentMonth : this.currentMonth;
		this.currentDay = this.currentDay < 10 ? '0' + this.currentDay : this.currentDay;
		if (common.is_weixin()) {
			common.wxShare('会议日历@血管资讯', '血管外科领域最新会议一览', 'cdn.edstatic.com/203012120000/bca5bbcde6b65142646518943d71936a/2020/09/8e44215d-f687-4be7-8ced-81c3c880587a.png');
		}
	},
	methods: {
		//当月会议
		getMonthMeetings(month, year) {
			this.$store.dispatch('isShowLoading', true);
			const url = MeetingMonth;
			const method = 'POST'
			let params = {
				month: month,
				year: year
			}
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						let data1 = JSON.parse(JSON.stringify(res.data));
						let data2 = JSON.parse(JSON.stringify(res.data));
						data1.forEach((item, index) => {
							item.start_at = ((item.start_at.split(' ')[0]).split('-')).join('.');
							let end_at_arr = (item.end_at.split(' ')[0]).split('-');
							item.end_at = end_at_arr[1] + '.' + end_at_arr[2];

						})
						this.monthMeetings = data1;
						data2.forEach((item, index) => {
							item.start_at = item.start_at.split(' ')[0];
							item.end_at = item.end_at.split(' ')[0];
						})
						this.monthMeetings2 = data2;
						this.$refs.calendar.init(data2);
						this.dateInRange(this.currentYear + '-' + this.currentMonth + '-' + this.currentDay);

					}
					this.$store.dispatch('isShowLoading', false);
				})
		},
		//今日会议
		getDayMeetings(data) {
			data.start_at = ((data.start_at.split(' ')[0]).split('-')).join('.');
			let end_at_arr = (data.end_at.split(' ')[0]).split('-');
			data.end_at = end_at_arr[1] + '.' + end_at_arr[2];
			this.dayMeetings = data;
		},
		//判断一个日期是否在时间范围内
		dateInRange(day) {
			console.log(day)
			this.dayMeetings = [];
			let timeStamp = new Date(day).getTime();
			let data = JSON.parse(JSON.stringify(this.monthMeetings2));    //深拷贝
			data.forEach((value, index) => {
				let startTime = value.start_at;
				let endTime = value.end_at;
				if (timeStamp >= new Date(startTime).getTime() && timeStamp <= new Date(endTime).getTime()) {
					value.start_at = ((value.start_at.split(' ')[0]).split('-')).join('.');
					let end_at_arr = (value.end_at.split(' ')[0]).split('-');
					value.end_at = end_at_arr[1] + '.' + end_at_arr[2];
					value.color_index = index
					this.dayMeetings.push(value)
				}
			})

		},
		goDetail(id, buttons_count) {
			if (buttons_count) {
				if (id == 286) {
					this.$router.push({
						path: '/CEC2022/index',
					})
				}
				else if (id == 348) {
					this.$router.push({
						path: '/CEC2023/index',
					})
				}
				else if (id == 399) {
					this.$router.push({
						path: '/CVSCF2023/index',
					})
				}
				else if (id == 483) {
					this.$router.push({
						path: '/XVC/index',
					})
				}
				else {
					this.$router.push({
						path: '/vascularNews/meeting/index',
						query: {
							meeting_id: id
						}
					})
				}
			}
			else {
				this.$router.push({
					path: '/vascularNews/meeting/live',
					query: {
						meeting_id: id
					}
				})
			}

		},
		// searchMeetings(val){
		// 	if(val&&!this.isNull(val)){
		// 		this.loading=true
		// 		const url=MeetingsSearch;
		// 		const method='POST';
		// 		const params={
		// 			keywords:val
		// 		};
		// 		fetch(url,params,method)
		// 		.then((res)=>{
		// 			this.loading=false
		// 			if(res.code==0){
		// 				this.resultMeetings=res.data;
		// 			}
		// 		})
		// 		}
		// },
		// searchMeetingsBlur(e){
		// 	if(e.target.value){
		// 		// this.loading=true
		// 		const url=MeetingsSearch;
		// 		const method='POST';
		// 		const params={
		// 			keywords:e.target.value
		// 		};
		// 		fetch(url,params,method)
		// 		.then((res)=>{
		// 			// this.loading=false
		// 			if(res.code==0){
		// 				this.resultMeetings=res.data;
		// 			}
		// 		})
		// 	}
		// },
		// isNull( str ){
		// 	if ( str == "" ) return true;
		// 	var regu = "^[ ]+$";
		// 	var re = new RegExp(regu);
		// 	return re.test(str);
		// },
		// goMeetingIndex(id){
		// 	if(id==286){
		// 		this.$router.push({
		// 			path:'/CEC2022/index',
		// 		})
		// 	}
		// 	else if(id==384){
		// 		this.$router.push({
		// 			path:'/CEC2023/index',
		// 		})
		// 	}
		// 	else if(id==399){
		// 		this.$router.push({
		// 			path:'/CVSCF2023/index',
		// 		})
		// 	}
		// 	else{
		// 		this.$router.push({
		// 			path:'/vascularNews/meeting/index',
		// 			query:{
		// 				meeting_id:id
		// 			}
		// 		})
		// 	}
		// 	this.keywords='';
		// },
		goSearch() {
			if (this.keywords) {
				this.$router.push({
					path: '/vascularNews/search',
					query: {
						keywords: this.keywords
					}
				})
			}
		}
	}

}
</script>
<style lang="scss" sc>
.meeting-calendar {
	.banner {
		background: white;

		img {
			margin: 5px 0;
		}
	}

	.name {
		letter-spacing: 0;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		line-height: 20px;
		color: #131313;
		font-size: 14px;
		-webkit-line-clamp: 2;
		/*要显示的行数*/
		-webkit-box-orient: vertical;
	}

	.calendar {
		background: white;
	}

	.van-tabs--line .van-tabs__wrap {
		border-bottom: 1px solid #979797;
	}

	.meeting-container {
		// background:#f1f2f4;
		margin-bottom: 60px;
		margin-top: 10px;

		.meeting-list1 {
			.meeting-header {
				display: flex;
				justify-content: space-between;
				width: 100%;
				padding: 10px 15px 5px;

				.title {
					color: #1F1F1F;
					// line-height: 50px;
					// padding-left: 15px;
					font-size: 14px;
					font-weight: normal;
					letter-spacing: 0px;

				}

				.meeting-number {
					border-radius: 10px;
					font-size: 14px;
					font-weight: normal;
					line-height: 20px;
					color: #901D22;
					background: #FFE6E7;
					padding: 0 10px;
					margin-bottom: 10px;
				}
			}

			.list-bg {
				background: white;
				border-radius: 10px;
				margin: 0 15px 10px;
				padding: 15px 15px 5px;

			}

			.item {
				display: flex;
				margin: 20px 0;

				.color-line {
					background: #4B85ED;
					width: 5px;
					height: 91px;
					display: inline-block;
					border-radius: 2.5px;
					margin-right: 15px;
				}

				img {
					width: 100%;
					border-radius: 0.2rem;

				}

				.image {
					width: 35%;
					margin: 0 0 0 4%;
				}

				.content {
					width: 61%;
					position: relative;
					font-size: 14px;
					padding: 5px 0;

					.bottom {
						position: absolute;
						bottom: 7px;
						font-size: 12px;
						line-height: 18px;
						color: #666666;
					}
				}
			}

		}
	}

	.el-input__inner {
		border-radius: 30px;
	}
}

.el-select-dropdown__item {
	max-width: 300px;
	display: inline-block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.el-select-dropdown {
	max-width: 340px;
}

.el-select .el-input.is-focus .el-input__inner {
	border-color: #d2020d !important;
}

.el-select .el-input__inner:focus {
	border-color: #d2020d !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Calendar/Calendar.vue